import { Avatar, Box, Drawer, ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDrawer = styled(Drawer)(() => ({
	width: '280px',
	flexShrink: 0,
	'& .MuiDrawer-paper': {
		width: '280px',
		padding: '24px',
		boxSizing: 'border-box',
		gap: '32px',
		display: 'flex',
		flexDirection: 'column',
	},
}));

export const LogoContainer = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '16px',
}));

export const NavigationContainer = styled(Box)(() => ({
	overflow: 'auto',
	flexGrow: 1,
}));

export const UserSection = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1.5),
	padding: theme.spacing(2),
	borderRadius: theme.shape.borderRadius,
	backgroundColor: theme.palette.grey[50],
	border: `1px solid ${theme.palette.divider}`,
	overflow: 'hidden',
}));

export const UserAvatar = styled(Avatar)(({ theme }) => ({
	width: 38,
	height: 38,
	fontSize: '0.875rem',
	flexShrink: 0,
	backgroundColor: theme.palette.primary.main,
}));

export const UserInfo = styled(Box)(() => ({
	flex: 1,
	minWidth: 0,
	overflow: 'hidden',
	'& .MuiTypography-root': {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		display: 'block',
	},
}));

export const LogoutButton = styled(ListItemButton)(({ theme }) => ({
	borderRadius: theme.shape.borderRadius,
	color: theme.palette.error.main,
	marginTop: theme.spacing(1),
	'& .MuiListItemIcon-root': {
		color: theme.palette.error.main,
		minWidth: 36,
	},
	'&:hover': {
		backgroundColor: theme.palette.error.light + '22',
	},
}));
